// extracted by mini-css-extract-plugin
module.exports = {"heroRow":"Hero_heroRow__WuDmS","showOnMobileOnly":"Hero_showOnMobileOnly__wdg1i","wrapper":"Hero_wrapper__7SWmn","leftColumn":"Hero_leftColumn__ASOJN"};